module.exports = __webpack_public_path__ + "static/media/ios-2.e1fe8c04.jpg";